import slugify from "slugify";

/**
 * Convert a string to a URL-friendly slug
 * @param text - The text to convert to a slug
 * @returns The URL-friendly slug
 */
export const createSlug = (text: string): string => {
  if (!text) return "";

  return (
    slugify(text, {
      lower: true,
      strict: true, // Remove special characters
      locale: "de", // Use German locale for proper umlaut handling
      remove: /[*+~.()'"!:@]/g, // Remove additional special characters
    }) || "page"
  );
};

/**
 * Find an info page by its slug
 * @param infoPages - Array of info pages
 * @param slug - The slug to search for
 * @returns The matching info page or null
 */
export const findInfoPageBySlug = (
  infoPages: any[],
  slug: string,
): any | null => {
  if (!infoPages || !Array.isArray(infoPages)) return null;

  return (
    infoPages.find((page) => {
      // Check both navigationLabel and title as fallback for compatibility
      const pageSlug = page.navigationLabel || page.navigation || page.title;
      return createSlug(pageSlug) === slug;
    }) || null
  );
};

/**
 * Get the slug for a specific info page
 * @param infoPage - The info page object
 * @returns The slug for the info page
 */
export const getInfoPageSlug = (infoPage: any): string => {
  if (!infoPage) return "page";

  // Prioritize navigationLabel, then navigation, then title for compatibility
  const text =
    infoPage.navigationLabel || infoPage.navigation || infoPage.title;
  if (!text) return "page";

  return createSlug(text);
};
